export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8321.0e2a7997.jpg";